import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 15,
    seconds: 0
  });
  useEffect(() => {
    // Check if we have a saved end time for this session
    let endTime = sessionStorage.getItem('midnightMagnetEndTime');
    if (!endTime) {
      // Set end time to 15 minutes from now
      const newEndTime = new Date().getTime() + 15 * 60 * 1000;
      sessionStorage.setItem('midnightMagnetEndTime', newEndTime.toString());
      endTime = newEndTime.toString();
    }
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = parseInt(endTime!) - now;
      if (distance <= 0) {
        clearInterval(interval);
        setTimeLeft({
          hours: 0,
          minutes: 0,
          seconds: 0
        });
      } else {
        setTimeLeft({
          hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
          minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
          seconds: Math.floor(distance % (1000 * 60) / 1000)
        });
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex justify-center items-center space-x-4 my-8" data-id="element-1">
      <div className="flex flex-col items-center" data-id="element-2">
        <div className="countdown-digit-box rounded-lg w-16 h-20 md:w-20 md:h-24 flex items-center justify-center mb-2" data-id="element-3">
          <span className="text-3xl md:text-5xl font-bold text-gold font-playfair" data-id="element-4">
            {formatNumber(timeLeft.hours)}
          </span>
        </div>
        <span className="text-xs text-lunar-muted tracking-widest uppercase" data-id="element-5">
          Hours
        </span>
      </div>

      <div className="text-2xl md:text-4xl text-cta-red font-bold self-start mt-4 md:mt-6 animate-pulse" data-id="element-6">
        :
      </div>

      <div className="flex flex-col items-center" data-id="element-7">
        <div className="countdown-digit-box rounded-lg w-16 h-20 md:w-20 md:h-24 flex items-center justify-center mb-2" data-id="element-8">
          <span className="text-3xl md:text-5xl font-bold text-gold font-playfair" data-id="element-9">
            {formatNumber(timeLeft.minutes)}
          </span>
        </div>
        <span className="text-xs text-lunar-muted tracking-widest uppercase" data-id="element-10">
          Minutes
        </span>
      </div>

      <div className="text-2xl md:text-4xl text-cta-red font-bold self-start mt-4 md:mt-6 animate-pulse" data-id="element-11">
        :
      </div>

      <div className="flex flex-col items-center" data-id="element-12">
        <div className="countdown-digit-box rounded-lg w-16 h-20 md:w-20 md:h-24 flex items-center justify-center mb-2" data-id="element-13">
          <span className="text-3xl md:text-5xl font-bold text-gold font-playfair" data-id="element-14">
            {formatNumber(timeLeft.seconds)}
          </span>
        </div>
        <span className="text-xs text-lunar-muted tracking-widest uppercase" data-id="element-15">
          Seconds
        </span>
      </div>
    </div>;
}